import {StringUtils} from '../../utils/string.utils';
import {ApiJsonResult} from '../../utils/api/apijsonresult';

export class ScopeQuestionareInProgress {
    id: number;
    childId: number;
    childProgressLevelTrackerId: number;
    quizId: number;
    question: string;
    questionHelp: string;
    scopeLevelMasterId: number;
    scopeProfileMasterId: number;
    answer: string;
    availableAnswersJson: string;
    therapistResponse: string;
    byParent: string;
    byTherapist: string;
    createdBy: string;
    createdDate: any;
    updatedBy: string;
    updatedDate: any;

    static populate(jsonObject: any): ScopeQuestionareInProgress {
        let obj = new ScopeQuestionareInProgress();
        obj.id = jsonObject.id;
        obj.childId = jsonObject.childId;
        obj.childProgressLevelTrackerId = jsonObject.childProgressLevelTrackerId;
        obj.quizId = jsonObject.quizId;
        obj.question = jsonObject.question;
        obj.questionHelp = jsonObject.questionHelp;
        obj.scopeLevelMasterId = jsonObject.scopeLevelMasterId;
        obj.scopeProfileMasterId = jsonObject.scopeProfileMasterId;
        obj.answer = jsonObject.answer;
        obj.availableAnswersJson = jsonObject.availableAnswersJson;
        obj.therapistResponse = jsonObject.therapistResponse;
        obj.byParent = jsonObject.byParent;
        obj.byTherapist = jsonObject.byTherapist;
        obj.createdBy = jsonObject.createdBy;
        obj.createdDate = jsonObject.createdDate;
        obj.updatedBy = jsonObject.updatedBy;
        obj.updatedDate = jsonObject.updatedDate;
        return obj;
    }

    static formPopulate(obj: ScopeQuestionareInProgress, jsonObject: any): ScopeQuestionareInProgress {
        if (obj == null) {
            obj = new ScopeQuestionareInProgress();
        }
        obj.id = jsonObject.id;
        obj.childId = jsonObject.childId;
        obj.childProgressLevelTrackerId = jsonObject.childProgressLevelTrackerId;
        obj.quizId = jsonObject.quizId;
        obj.question = jsonObject.question;
        obj.scopeLevelMasterId = jsonObject.scopeLevelMasterId;
        obj.scopeProfileMasterId = jsonObject.scopeProfileMasterId;
        obj.answer = jsonObject.answer;
        obj.availableAnswersJson = jsonObject.availableAnswersJson;
        obj.therapistResponse = jsonObject.therapistResponse;
        obj.byParent = jsonObject.byParent;
        obj.byTherapist = jsonObject.byTherapist;
        obj.createdBy = jsonObject.createdBy;
        obj.createdDate = jsonObject.createdDate;
        obj.updatedBy = jsonObject.updatedBy;
        obj.updatedDate = jsonObject.updatedDate;
        return obj;
    }

    static apimapper(apijsonResult: ApiJsonResult): ScopeQuestionareInProgress {
        let obj = null;
        if (!StringUtils.isEmpty(apijsonResult.outputjson)) {
            let jsonObject = JSON.parse(apijsonResult.outputjson);
            obj = ScopeQuestionareInProgress.populate(jsonObject);
        }
        return obj;
    }

    static apimapperLst(apijsonResult: ApiJsonResult): ScopeQuestionareInProgress [] {
        let lst: ScopeQuestionareInProgress [] = [];
        if (!StringUtils.isEmpty(apijsonResult.outputjson)) {
            let jsonObject = JSON.parse(apijsonResult.outputjson);
            for (let i = 0; i < jsonObject.length; i++) {
                lst.push(ScopeQuestionareInProgress.populate(jsonObject[i]));
            }
            return lst;
        }
    }
}
